import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
	getPersonSendInviteQueue,
	SendInviteQueueItem,
} from "../../api/person/send-invite-queue";
import { formatDateTime } from "../../utils/date-formatting";
import { useGlobalState } from "../globalState";

interface PersonSendInviteQueueProps {
	personId: number;
}

export const PersonSendInviteQueue = ({ personId }: PersonSendInviteQueueProps) => {
	const [items, setItems] = useState<SendInviteQueueItem[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const { currentUser } = useGlobalState();

	useEffect(() => {
		if (!currentUser.is_superuser || !personId) {
			setLoading(false);
			return;
		}

		getPersonSendInviteQueue(personId)
			.then((res) => setItems(res.results))
			.finally(() => setLoading(false));
	}, [personId, currentUser.is_superuser]);

	if (!currentUser.is_superuser || loading) {
		return null;
	}

	return (
		<Accordion defaultExpanded={false} data-component="send-invite-queue-accordion">
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				data-component="send-invite-queue-summary"
			>
				<Typography variant="h6">
					SendInvitationsQueue ({items.length})
				</Typography>
			</AccordionSummary>
			<AccordionDetails data-component="send-invite-queue-details">
				<TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
					<Table size="small" sx={{ minWidth: 600 }}>
						<TableHead>
							<TableRow>
								<TableCell>ID</TableCell>
								<TableCell>Created</TableCell>
								<TableCell>Assignment</TableCell>
								<TableCell>Type</TableCell>
								<TableCell>Priority</TableCell>
								<TableCell>Queued by</TableCell>
								<TableCell>Last sent invite</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{items.map((item) => (
								<TableRow key={item.id} data-component="queue-row">
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.id}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{formatDateTime(item.created)}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.assignment_name || "—"}
										</Typography>
									</TableCell>
									<TableCell>
										<Chip label={item.type} size="small" />
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.priority}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.user_name || "—"}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.last_sent_invite
												? formatDateTime(item.last_sent_invite)
												: "—"}
										</Typography>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</AccordionDetails>
		</Accordion>
	);
};
